<template>
	<div class="order-page">
		<div class="header">
			<div class="round-btn" @click="onBackClick"><Icon name="arrow-left" size="22" /></div>
			<div style="flex: 1"></div>
			<div class="round-btn"><Icon name="weapp-nav" size="20" /></div>
		</div>
		<Swipe :autoplay="3000" :height="260">
		  <SwipeItem v-for="(image, index) in images" :key="index">
		    <img v-lazy="image" style="height: 100%" />
		  </SwipeItem>
		</Swipe>
		<Cell :border="false">
		  <div class="box">
			  <div class="box-right">
				  <p class="title">{{ target.goodsInfo && target.goodsInfo.goodsName }}</p>
				  <p class="text">监控价格<span class="price">{{target.goodsInfo &&  target.goodsInfo.price }} / {{target.goodsInfo && target.goodsInfo.unit || '天'}}</span></p>
			  </div>
		  </div>
	  </Cell>
		<div class="split"></div>
		<Cell title="服务说明" />
		<div class="good-html" v-html="target.goodsInfo && target.goodsInfo.description"></div>
		<Divider>
		  商品详情
		</Divider>
		<div class="detail">
			<div v-html="target.goodsInfo && target.goodsInfo.details"></div>
		</div>
		<GoodsAction>
		  <!--<GoodsActionIcon icon="chat-o" :dot="hasMessage" text="客服" />-->
		  <GoodsActionIcon icon="cart-o" :badge="shopCarCount"  text="购物车" @click="$router.push('/buyCar')" />
		  <GoodsActionButton :disabled="hasInShopCar" @click="onAddCardClick" color="#ff5778" type="warning" text="加入购物车" />
		  <GoodsActionButton @click="onBuyClick" color="#ed143f" type="danger" text="立即购买" />
		</GoodsAction>
	</div>
</template>

<script>
	import { NavBar, Button, Icon, Swipe, SwipeItem, Lazyload, Cell, Divider, GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant'

	export default {
	  components: {NavBar, Button, Icon, Swipe, SwipeItem,Cell, Divider, GoodsAction, GoodsActionIcon, GoodsActionButton},
    data() {
      return {
        target: {},
        images: [],
      };
    },
		computed: {
	    shopCarCount() {
	      return this.$store.state.shopCar.length
	    },
			hasMessage() {
	      return true
			},
			hasInShopCar() {
	      return this.$store.state.shopCar.findIndex(v => v.goodsInfo.id === this.target.goodsInfo.id) !== -1
			}
		},
    created() {
	    // if(this.$router.isBack) return;
	    this.$axiox.post('/goodsInfo/goodsDetail', {id: this.$route.query.id}).then(p => {
        const target = p.data;
        this.target = target;
        this.images = target.goodsImages.map(v => v.imageUrl);
      })
		},
	  methods: {
      onBackClick() {
        this.$router.back();
      },
      onAddCardClick() {
				this.$store.dispatch('addShopCar', this.target);
      },
      onBuyClick() {
        this.$router.push({
	        name: 'orderPay',
	        params: { ...this.target }
        })
      }
	  }
	}
</script>

<style lang="less" scoped>
	.order-page {
		background: #f5f5f5;
		height: 100%;
		overflow-y: scroll;
		padding-bottom: 50px;
		box-sizing: border-box;
	}
	.header {
		background: transparent;
		height: 46px;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 15px;
	}

	.box {
		display: flex;
		padding: 15px;

		&-left {
			padding-right: 15px;
		}

		.title {
			font-size: 16px;
			font-weight: bold;
			text-align: left;
			line-height: 20px;
		}

		.text {
			font-size: 14px;
			color: #646566;
			display: block;
			text-align: left;

			.price {
				font-size: 20px;
				margin-left: 15px;
				color: red;
			}
		}
	}

	.round-btn {
		background: #858485;
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50px;
		width: 35px;
		height: 35px;
		box-sizing: border-box;

		/deep/.van-icon {
			color: white;
			font-size: 25px;
		}
	}

	/deep/.van-divider {
		background: #f5f5f5;
	}

	.no-data {
		margin: 15px;
		color: #ddd;
	}

	.good-html {
		padding: 10px;
		background: #fff;
	}
</style>
